import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[capture-host]'
})
export class CaptureDirective 
{
  constructor(public viewContainerRef: ViewContainerRef) { }
}
